import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Dashboard.css";
import BeforeLogin from "../BeforeLogin";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiArrowDownSLine } from "react-icons/ri";
import Cookies from "js-cookie";
import storage from "../../../../Storage";
import { API } from "../../../../Helper";

const getUID = () => parseFloat(Cookies.get("uid"));


const Dashboard = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [token] = useState(storage.getKey('token') || null);
  const [uid] = useState(getUID()); // Get UID immediately from cookie
  const [logged, setLogged] = useState(false);
  const [refrelCode, setRefrelCode] = useState("");
  const [refrelLink, setRefrelLink] = useState("");
  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);
  const [openDashbaord, setOpenDashbaord] = useState(false);
  const [members, setMembers] = useState([]);
  const [totalMembers, setTotalMembers] = useState(0);
  const [ownerName, setOwnerName] = useState("");
  const [rewards, setRewards] = useState({});
  const [userInfo, setUserInfo] = useState({});

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const rewardsData = [
    {
      name: "Alice",
      amount: "+1.2",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Bob",
      amount: "+0.8",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Charlie",
      amount: "+2.0",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "David",
      amount: "+0.7",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Eve",
      amount: "+1.5",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Frank",
      amount: "+1.0",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Grace",
      amount: "+0.9",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Hannah",
      amount: "+1.8",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Ian",
      amount: "+1.3",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Jack",
      amount: "+2.5",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Kim",
      amount: "+0.6",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Liam",
      amount: "+1.7",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Mona",
      amount: "+2.3",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Nina",
      amount: "+1.1",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
    {
      name: "Oscar",
      amount: "+1.9",
      icon: "/assets/bcimages/bcaffiliate/INR-icon.webp",
    },
    {
      name: "Paul",
      amount: "+2.1",
      icon: "/assets/bcimages/bcaffiliate/USDT-icon.webp",
    },
  ];
  const [position, setPosition] = useState(0);
  const itemHeight = 40;
  const scrollSpeed = 30;

  // Duplicate rewards data to ensure smooth scrolling
  const duplicatedRewards = [...rewardsData, ...rewardsData];

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => {
        return prev >= itemHeight * rewardsData.length ? 0 : prev + 1;
      });
    }, scrollSpeed);

    return () => clearInterval(interval);
  }, [itemHeight]);

  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "How does the referral system work?",
      answer:
        `When you share your referral link with any of your friends, family, or advertise the link and a player signs up at our site, that player becomes your referral and they will earn you commission & extra rewards by playing at ${process.env.REACT_APP_LINK}.`,
    },
    {
      question: "How much can I earn from my referral?",
      answer: "You can earn 25% of their wager + $84,925.32 per referral.",
    },
    {
      question: "What is USD reward and how does it work?",
      answer:
        `There is $84,925.32 USD reward for each referral you bring to ${process.env.REACT_APP_LINK}. This USD reward is given in 10 parts when your referral levels up from VIP4 to VIP70.`,
    },
    {
      question: "Are there any banners I can use to advertise?",
      answer: "Yes, we offer multiple banner sizes for your convenience.",
    },
    {
      question: "I have big audience, how I can get special deals?",
      answer:
        "If you have a website with good traffic or social media account with big audience, you can connect with us at trubetx@gmail.com for special deals.",
    },
    {
      question:
        "How many affiliate links can I create if I have different websites/accounts?",
      answer:
        "You can create up to 20 unique codes for different source of traffic.",
    },
    {
      question: "Can I see the data of my referral?",
      answer:
        `Yes, ${process.env.REACT_APP_LINK} believes in total transparency and offers all data to the users like username, total wager and commission earned, date of registration and referral link applied. You can see all of this information in your Affiliate Dashboard.`,
    },
    {
      question: "Can I send tip or reward to my referrals?",
      answer: "Yes, you can send your referrals tips in any supported coins.",
    },
  ];

  // Toggle active question
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          className: "Toastify__toast--custom",
        });
      })
      .catch((err) => {
        console.error("Failed: ", err);
        toast.error("Failed to copy!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const socialLinks = [
    {
      href: `https://www.facebook.com/sharer.php?u=url=https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F&amp;title=My%20Referral&amp;text=`,
      imgSrc: "/assets/bcimages/bcaffiliate/facebook_icon.webp",
      alt: "Share on Facebook",
    },
    {
      href: `https://www.twitter.com/share?url=https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F&text=My%20Referral`,
      imgSrc: "/assets/bcimages/bcaffiliate/twitter_icon.webp",
      alt: "Share on Twitter",
    },
   
    {
      href: `https://line.me/R/msg/text/?My%20Referral%20https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F`,
      imgSrc: "/assets/bcimages/bcaffiliate/line_icon.webp",
      alt: "Share on LINE",
    },
    {
      href: `https://web.skype.com/share?url=https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F&text=My%20Referral`,
      imgSrc: "/assets/bcimages/bcaffiliate/skype_icon.webp",
      alt: "Share on Skype",
    },
   
    {
      href: `https://www.linkedin.com/shareArticle?url=https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F&title=My%20Referral`,
      imgSrc: "/assets/bcimages/bcaffiliate/linkedin_icon.webp",
      alt: "Share on LinkedIn",
    },
    {
      href: `https://api.whatsapp.com/send?text=My%20Referral%20https%3A%2F%2F${process.env.REACT_APP_LINK}%2Freferal%2F${refrelCode}%2F`,
      imgSrc: "/assets/bcimages/bcaffiliate/whatsapp_icon.webp",
      alt: "Share on WhatsApp",
    },
  ];


 

    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        if (token !== null) {
            setLogged(true);
        }

        // Fetch all data immediately
        fetchAllData();
    }, []);

    const fetchAllData = () => {
        getRefrelCode();
        getRefrelLink();
        getMembers();
        getTodayRewards();
        getMyProfile();
    };

    const getTodayRewards = () => {
        fetch(`${API}/api/myAffiliate/${uid}?filter=all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data) {
                setRewards(data);
                console.log("myAffiliate", data)
            }
        })
        .catch(error => console.log("error fetching today's rewards", error));
    };

    const getMembers = () => {
        fetch(`${API}/api/members/${uid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            setOwnerName(data.ownername);
            setTotalMembers(data.totalMembers);
            setMembers(data.members);
        })
        .catch(error => console.log("error fetching members", error));
    };

    const getRefrelCode = () => {
        fetch(`${API}/get-referral-code/${uid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data.referralCode) {
                setRefrelCode(data.referralCode);
            }
        })
        .catch(error => console.log("error", error));
    };

    const getRefrelLink = () => {
        fetch(`${API}/get-referral-link/${uid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data.referralLink) {
                setRefrelLink(data.referralLink);
            }
        })
        .catch(error => console.log("error", error));
    };

    const getMyProfile = () => {
        fetch(`${API}/api/myproifle/${uid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data?.data) {
                setUserInfo(data?.data[0]);
                console.log(data)
            }
        })
        .catch(error => console.log("error", error));
    };

    // const copyToClipboard = (text, type) => {
    //     navigator.clipboard.writeText(text).then(() => {
    //         if (type === 'link') {
    //             setCopiedLink(true);
    //             setTimeout(() => setCopiedLink(false), 2000);
    //         } else {
    //             setCopiedCode(true);
    //             setTimeout(() => setCopiedCode(false), 2000);
    //         }
    //     }).catch(err => {
    //         console.error('Failed to copy text: ', err);
    //     });
    // };


  return (
    <div>
      <div className="affiliate-dashboard-main">
        <div className="affiliate-dashboard-container">
          <div className="affiliate-dashboard-refferal-commission">
            <div className="refferal-rewards-commmission">
              <div className="dash-invite-top">
                <div className="invite-top-inner">
                  <p>Invite a Friend to Get</p>
                  <div className="dash-invite-bottom">
                    <p>
                      <span className="dash-invite-bottom-span">
                        ${rewards?.totalReferralReward + userInfo?.total_signup_bonus_amount}
                      </span>
                      <span className="second-span-dash">Referral Rewards</span>
                    </p>
                    <div className="invite-bootom-div"></div>
                    <p>
                      <span className="dash-invite-bottom-span">25%</span>
                      <span className="second-span-dash">
                        Commission Rewards
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <p className="dash-p">
                Get $1,000.00 for each friend you invite, plus up to 25%
                commission on their wagers. Enjoy consistent commission, whether
                they win or lose, in our Casino and Sportsbook. Start earning
                now!
              </p>
              <div className="refferal-link-code">
                <div className="refferal-link-section">
                  <p>Referral Link</p>
                  <div className="refferal-link-inner">
                    <p>{refrelLink}</p>
                    <button
                      onClick={() =>
                        copyToClipboard(refrelLink)
                      }
                    >
                      Copy
                    </button>
                  </div>
                </div>
                <div className="refferal-link-section">
                  <p>Referral Code</p>
                  <div className="refferal-link-inner">
                    <p>{refrelCode}</p>
                    <button onClick={() => copyToClipboard(refrelCode)}>
                      Copy
                    </button>
                  </div>
                </div>
              </div>
              <div className="share-social-icon">
                <span>Share via socials</span>
                <div className="share-social-icon-inner">
                  {socialLinks.map((link, index) => (
                    <a
                      key={index}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-none"
                      href={link.href}
                    >
                      <img className="icon" src={link.imgSrc} alt={link.alt} />
                    </a>
                  ))}
                </div>
              </div>
              <div className="referral-terms-conditions-button">
                <button onClick={toggleModal}>
                  Referral Terms & Conditions
                </button>
              </div>
            </div>
            <div className="affiliate-dashboard-rewards-friends">
              <div className="dashboard-total-rewards-friends">
                <div className="total-rewards">
                  <img
                    src="/assets/bcimages/bcaffiliate/total_rewards.png"
                    alt="reward icon"
                  />
                  <p className="total-rewards-title">Total Reward</p>
                  <p className="total-rewards-amount">${rewards?.totalReferralReward + userInfo?.total_signup_bonus_amount}</p>
                </div>
                <div className="total-friends">
                  <img
                    src="/assets/bcimages/bcaffiliate/total_friends.png"
                    alt="reward icon"
                  />
                  <p className="total-rewards-title">Total Friends</p>
                  <p className="total-rewards-amount">{rewards?.totalFriends}</p>
                </div>
              </div>
              <div className="affiliate-dashboard-rewards">
                <div className="affiliate-dashboard-refferal-rewards">
                  <img
                    src="/assets/bcimages/bcaffiliate/refferal-reward.png"
                    alt="reward icon"
                  />
                  <p className="refferal-reward-title">Referral Rewards</p>
                  <span className="total-rewards-amount">${rewards?.totalReferralReward}</span>
                </div>
                <div className="affiliate-dashboard-refferal-rewards">
                  <img
                    src="/assets/bcimages/bcaffiliate/commision-reward.png"
                    alt="reward icon"
                  />
                  <p className="refferal-reward-title">Commission Rewards</p>
                  <span className="total-rewards-amount">${rewards?.totalCommissionReward}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="rewards-activities-main-container">
            <div className="rewards-activities-title">Rewards Activities</div>
            <div className="bot-info">
              <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
                <img
                  className="img-fluid"
                  style={{ width: "12rem", height: "12rem" }}
                  src="\assets\bcimages\bcaffiliate\reward-activity-empty.webp"
                  alt="Empty"
                />
                <div className="reward-activities-font mt-4 text-center">
                  <p className="mb-1">No info yet</p>
                  <p>Invite friends to join you now!</p>
                </div>
              </div>
            </div>
          </div>

          {/* Affiliate Live Rewards  */}
          <div className="affiliate-live-rewards">
            <div className="affiliate-live-rewards-left">
              <div className="d-flex align-items-center">
                <b className="live-rewards-dot"></b>
                <p className="fw-bold mb-0">Live Rewards</p>
              </div>
              <div className="affiliate-live-rewards-left-amount">
                <p className="mb-0">Total Rewards Sent To-Date</p>
                <div className="affiliate-live-rewards-left-amount-value">
                  $2,090,203.21K
                </div>
              </div>
            </div>
            <div
              className="affiliate-live-rewards-right"
              style={{ overflow: "hidden" }}
            >
              <div
                className="affiliate-live-rewards-right-contant"
                style={{
                  transform: `translateY(-${position}px)`,
                  transition: "none",
                }}
              >
                {duplicatedRewards.map((reward, index) => (
                  <div
                    key={index}
                    className="affiliate-live-rewards-right-contant-columns"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px 10px",
                      fontWeight: "600",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>{reward.name}</p>
                    <div className="amount-increase d-flex align-items-center g-1">
                      <p style={{ marginBottom: "0px" }}>{reward.amount}</p>
                      <img
                        src={reward.icon}
                        alt="Icon"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginLeft: "5px",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Affiliate Program */}

          <div className="affiliate-program-main">
            <div className="affiliate-program">
              <p className="affiliate-program-title">
                Learn more about our <span>Affiliate program</span>
              </p>
              <img src="/assets/bcimages/bcaffiliate/affiliate-program-image.webp" />
              <div className="affiliate-program-content">
                If you have a large audience and followers. We have special
                conditions for you to customize your referral program!
              </div>
              <div className="affiliate-program-content">
                If you can invite players and their wager amount reaches a
                billion dollars and above, you will get your own customized
                casino! You can set up a casino website with your domain and
                design style.
              </div>
              {/* <div className="affiliate-program-content-bottom">
                <div className="affiliate-program-content">
                  <span>for more details, please contact Us</span>
                </div>
                <div className="affiliate-business-email">
                  <p>business@ag.game</p>
                  <a target="_self" href="mailto:business@bc.game">
                    <button>Send Now</button>
                  </a>
                </div>
              </div> */}
            </div>
          </div>

          {/* Affiliate FAQ */}
          <div className="faq-main-conatiner">
            <div className="faq-heading-conatiner">
              <p>Frequently Asked Questions</p>
            </div>
            <div className="faq-questions-conatiner">
              {faqData.map((item, index) => (
                <div style={{ fontWeight: "500" }} key={index}>
                  <h4
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                    style={{
                      cursor: "pointer",
                      color: "#FFFFFF",
                      fontWeight: "700",
                    }}
                  >
                    {item.question}
                    <span className="faq-icon">
                      {activeIndex === index ? (
                        <RiArrowDownSLine />
                      ) : (
                        <MdKeyboardArrowRight />
                      )}
                    </span>
                  </h4>
                  {activeIndex === index && (
                    <p className="faq-answer">{item.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* refferal Modal Component */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Referral Terms & Conditions"
        className="custom-modal"
        overlayClassName="custom-overlay"
      >
        <h2>Referral Terms & Conditions</h2>
        <button onClick={toggleModal} className="close-modal-button">
          <RxCross2 />
        </button>
        <div
          className="modal-content-affiliate"
          style={{ overflowX: "scroll", height: "85vh" }}
        >
          <p>The website is supported by the {process.env.REACT_APP_LINK} prediction platform.</p>
          <p>Platform games include Crash, Classic Dice and so on.</p>

          <p style={{ marginTop: "15px" }}>
            By completing the {process.env.REACT_APP_LINK} Affiliate Program (the "Affiliate Program")
            application and clicking "I agree to the Terms and Conditions (the
            “Terms”)” within the registration form, you (hereinafter the
            "Affiliate") hereby agree to abide by all the terms and conditions
            set out in this agreement. The commission structure of the
            "commission rules" is also an integral part of this agreement.
            {process.env.REACT_APP_LINK} reserves the right to amend, alter, delete or extend any
            provisions of this agreement, at any time and at its sole
            discretion, without giving any advance notice to the Affiliate
            subject to the Terms set out in this agreement. You hereby agree to:
          </p>
          <p style={{ marginTop: "15px" }}>
            1. Participate in the Affiliate Program
          </p>
          <p style={{ marginTop: "15px" }}>
            2. Use of the {process.env.REACT_APP_LINK} affiliate website and/or {process.env.REACT_APP_LINK} marketing tools
            (as hereafter defined).
          </p>
          <p style={{ marginTop: "15px" }}>
            3. The condition that the acceptance of any affiliate commissions
            from {process.env.REACT_APP_LINK} confirms your irrevocable acceptance of this Agreement
            and any modifications thereto.
          </p>
          <p style={{ marginTop: "15px" }}>
            Therefore you shall be obliged to continuously comply with the Terms
            of this Agreement as well as to comply with the General Terms and
            Conditions and Privacy Policy of the website {process.env.REACT_APP_LINK}, as well as with
            any other rules and/or guidelines brought forward from time to time.
            An Agreement between the Company and the Affiliate comes into effect
            on the date the affiliate application is approved.
          </p>
          <h5>1.Purpose</h5>
          <p style={{ marginTop: "15px" }}>
            1.1. The Affiliate maintains and operates one or more websites on
            the Internet (hereinafter collectively referred to as "the
            Website"), and/or refers potential customers through other channels.
          </p>
          <p style={{ marginTop: "15px" }}>
            1.2. This Agreement governs the terms and conditions which are
            related to the promotion of the website {process.env.REACT_APP_LINK} by the Affiliate,
            hereinafter referred to as "{process.env.REACT_APP_LINK}", whereby the Affiliate will be
            paid a commission as defined in this Agreement depending on the
            traffic sent to {process.env.REACT_APP_LINK} and the terms of this Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            1.3. The definition of the term Net Gaming Revenue can be found
            within Article 20 of this Agreement. In case of an introduction of
            another product, or group of products in the future, {process.env.REACT_APP_LINK} reserves
            the right to use an individual definition of the term Net Gaming
            Revenue for each product.
          </p>
          <h5>2. Acceptance of an Affiliate</h5>
          <p style={{ marginTop: "15px" }}>
            2.1. The Company reserves the right to refuse any registration in
            its sole and absolute discretion.
          </p>
          <h5>3. Qualifying Conditions</h5>
          <p style={{ marginTop: "15px" }}>
            3.1. The Affiliate hereby warrants that he/she:
          </p>
          <p style={{ marginTop: "15px" }}>
            {" "}
            a) Is of legal age in the applicable jurisdiction in order to agree
            to and to enter into an Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            {" "}
            b) Is competent and duly authorized to enter into binding
            Agreements.
          </p>
          <p style={{ marginTop: "15px" }}>
            {" "}
            c) Is the proprietor of all rights, licences and permits to market,
            promote and advertise {process.env.REACT_APP_LINK} in accordance with the provisions of
            this Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            {" "}
            d) Will comply with all applicable rules, laws and regulations in
            correlation with the promotion of {process.env.REACT_APP_LINK}.
          </p>
          <p style={{ marginTop: "15px" }}>
            {" "}
            e) Fully understands and accepts the Terms of the Agreement.
          </p>
          <h5>4. Responsibilities and Obligations of the Company</h5>
          <p style={{ marginTop: "15px" }}>
            4.1. The Company shall provide the Affiliate with all required
            information and marketing material for the implementation of the
            tracking link.
          </p>
          <p style={{ marginTop: "15px" }}>
            4.2. The Company shall administrate the turnover generated via the
            tracking links, record the revenue and the total amount of
            commission earned via the link, provide the Affiliate with
            commission statistics, and handle all customer services related to
            the business. A unique tracking identification code will be assigned
            to all referred customers.
          </p>
          <p style={{ marginTop: "15px" }}>
            4.3. The Company shall pay the Affiliate the amount due depending on
            the traffic generated subject to the Terms of this Agreement.
          </p>
          <h5>5. Responsibilities and Obligations of the Affiliate</h5>
          <p style={{ marginTop: "15px" }}>
            5.1. The Affiliate hereby warrants:
          </p>
          <p style={{ marginTop: "15px" }}>
            a) To use its best efforts to actively and effectively advertise,
            market and promote {process.env.REACT_APP_LINK} as widely as possible in order to maximize
            the benefit to the parties and to abide by the guidelines of the
            Company as they may be brought forward from time to time and/or as
            being published online.
          </p>
          <p style={{ marginTop: "15px" }}>
            b) To market and refer potential players to host at its own cost and
            expense. The Affiliate will be solely responsible for the
            distribution, content and manners of its marketing activities. All
            of the Affiliate's marketing activities must be professional, proper
            and lawful under applicable laws and must be in accordance with this
            Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            c) To use only the tracking link provided within the scope of the
            affiliate program, otherwise no guarantee whatsoever can be given
            for proper registration and sales accounting. Also, not to change or
            modify in any way any link or marketing material without prior
            written authorization from the Company.
          </p>
          <p style={{ marginTop: "15px" }}>
            d) To be responsible for the development, operation and maintenance
            of its website as well as for all material appearing on its website.
          </p>
          <p style={{ marginTop: "15px" }}>
            5.2. The Affiliate hereby warrants:
          </p>
          <p style={{ marginTop: "15px" }}>
            a) That it will not perform any act which is libelous,
            discriminatory, obscene, unlawful or otherwise unsuitable or which
            contains sexually explicit, pornographic, obscene or graphically
            violent materials.
          </p>
          <p style={{ marginTop: "15px" }}>
            b) That it will not actively target any person who is under the
            legal age for gambling.
          </p>
          <p style={{ marginTop: "15px" }}>
            c) That it will not actively target any jurisdiction where gambling
            and the promotion thereof is illegal.
          </p>
          <p style={{ marginTop: "15px" }}>
            d) That it will not generate traffic to {process.env.REACT_APP_LINK} by illegal or
            fraudulent activity, particularly but not limited to:
          </p>
          <p style={{ marginTop: "15px" }}>I. Sending spam.</p>
          <p style={{ marginTop: "15px" }}>II. Incorrect metatags.</p>
          <p style={{ marginTop: "15px" }}>
            III. Registering as a player or making deposits directly or
            indirectly to any player account through his/her tracker(s) for
            their own personal use and/or the use of its relatives, friends,
            employees or other third parties, or in any other way attempt to
            artificially increase the commission payable or to otherwise defraud
            the Company. Violation of this provision shall be deemed to be
            fraud.
          </p>
          <p style={{ marginTop: "15px" }}>
            e) That it will not present its website in such a way that it might
            evoke any risk of confusion with {process.env.REACT_APP_LINK} and/or the Company and or
            convey the impression that the website of the contracting party is
            partly or fully originated with {process.env.REACT_APP_LINK} and/or the Company.
          </p>
          <p style={{ marginTop: "15px" }}>
            f) Without prejudice to the marketing material as may be forwarded
            by the Company and/or made available online through the website
            https://{process.env.REACT_APP_LINK}/ the affiliate may not use {process.env.REACT_APP_LINK} or other terms,
            trademarks and other intellectual property rights that are vested in
            the Company unless the Company consents to such use in writing.
          </p>
          <h5>6. Payment</h5>
          <p style={{ marginTop: "15px" }}>
            6.1. The Company agrees to pay the Affiliate a commission based on
            the Game bet amount generated from new customers referred by the
            Affiliate’s website and/or other channel. New customers are those
            customers of the Company who do not yet have a gaming account and
            who access the Website via the tracking link and who properly
            register and make bitcoin transfers at least equivalent to the
            minimum deposit into their {process.env.REACT_APP_LINK} betting account. The commission
            shall be deemed to be inclusive of value added tax or any other tax
            if applicable.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.2. The commission shall be a percentage of the Game bet amount in
            accordance with what is set out in the commission structures for the
            particular product. The calculation is product specific and it is
            set out in every product-specific commission structure. (see
            "commission rules" for details)
          </p>
          <p style={{ marginTop: "15px" }}>
            6.3. Users can withdraw commissions from the agent system at any
            time. The commissions will be withdrawn into the platform wallet.
            Users can also withdraw the platform wallet to any address at any
            time. (you can check the Commission extraction in the agent system
            and view transaction records in the platform wallet).
          </p>
          <p style={{ marginTop: "15px" }}>
            6.4. The commissions will be collected in digital currency and will
            only be received on the platform wallet.When applying for Withdraw,
            you must submit the correct wallet address on the “Withdraw” page.If
            there is an error in calculating the commission, the company has the
            right to amend the amount at any time and immediately settle the
            underpaid difference to the agent or recover the overpaid balance
            from the agent.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.5. Agent Withdraw commission by the Affiliate shall be deemed to
            be full and the final settlement of the balance due for the period
            indicated.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.6. If the Affiliate disagrees with the balance due as reported, it
            shall within a period of seven (7) days send an email to the Company
            to admin@{process.env.REACT_APP_LINK} and indicate the reasons for the dispute. Or contact
            customer service through Telegram .Failure to send an email Or
            contact customer service through Telegram within the prescribed time
            limit shall be deemed to be considered as an irrevocable
            acknowledgment of the balance due for the period indicated.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.7. May delay the Withdraw request through the agent for up to
            sixty (60) days, while it investigates and verifies that the
            relevant transactions comply with the provisions of the Terms.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.8. No payment shall be due when the traffic generated is illegal
            or contravenes any provision of these Terms.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.9. The Affiliate agrees to return all commissions received based
            on fraudulent or falsified transactions, plus all costs for legal
            causes or actions that may be brought against the Affiliate to the
            fullest extent of the law.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.10. For the sake of clarity the parties specifically agree that
            upon termination of this Agreement by either party, In addition to
            the previous unsettled Commissions, the Commissions of the agent
            will no longer be settled.
          </p>
          <p style={{ marginTop: "15px" }}>
            6.11. The Affiliate shall be exclusively responsible for the payment
            of any and all taxes, levies, fees, charges and any other money
            payable or due both locally and abroad (if any) to any tax
            authority, department or other competent entity by the Affiliate as
            a result of the commission generated under this Agreement. The
            Company shall in no manner whatsoever be held liable for any amounts
            unpaid but found to be due by the Affiliate and the Affiliate hereby
            indemnifies the Company in that regard.
          </p>
          <h5>7. Termination</h5>
          <p style={{ marginTop: "15px" }}>
            7.1. This Agreement may be terminated by either party by giving a
            thirty (30) day written notification to the other party. Written
            notification may be given by email.
          </p>
          <p style={{ marginTop: "15px" }}>
            7.2. The contracting parties hereby agree that upon termination of
            this Agreement:
          </p>
          <p style={{ marginTop: "15px" }}>
            a) The Affiliate must remove all references to {process.env.REACT_APP_LINK} from the
            Affiliate's websites and/or other marketing channels and
            communications, irrespective of whether the communications are
            commercial or non-commercial.
          </p>
          <p style={{ marginTop: "15px" }}>
            b) All rights and licenses granted to the Affiliate under this
            Agreement shall immediately terminate and all rights shall revert to
            the respective licensors, and the Affiliate will cease the use of
            any trademarks, service marks, logos and other designations vested
            in the Company.
          </p>
          <p style={{ marginTop: "15px" }}>
            c) The Affiliate will be entitled only to those earned and unpaid
            commissions as of the effective date of termination;however
            provided, the Company may withhold the Affiliate's final payment for
            a reasonable time to ensure that the correct amount is paid. The
            Affiliate will not be eligible to earn or receive commissions after
            this termination date.
          </p>
          <p style={{ marginTop: "15px" }}>
            d) If this Agreement is terminated by the Company on the basis of
            the Affiliate's breach, the Company shall be entitled to withhold
            the Affiliate’s earned but unpaid commissions as of the termination
            date as collateral for any claim arising from such a breach. It is
            further specified that termination by the Company due to a breach by
            the Affiliate of any of the clauses in this Agreement shall not
            require a notice period and such termination shall have immediate
            effect upon simple notification by the Company to the Affiliate.
          </p>
          <p style={{ marginTop: "15px" }}>
            e) The Affiliate must return to the Company any and all confidential
            information (and all copies and derivations thereof) in the
            Affiliate's possession, custody and control.
          </p>
          <p style={{ marginTop: "15px" }}>
            f) The Affiliate will release the Company from all obligations and
            liabilities occurring or arising after the date of such a
            termination, except with respect to those obligations that by their
            nature are designed to survive termination. Termination will not
            relieve the Affiliate from any liability arising from any breach of
            this Agreement, which occurred prior to termination and/or to any
            liability arising from any breach of confidential information even
            if the breach arises at any time following the termination of this
            Agreement. The Affiliate’s obligation of confidentiality towards the
            Company shall survive the termination of this Agreement.
          </p>
          <h5>8. Warranties</h5>
          <p style={{ marginTop: "15px" }}>
            8.1. The Affiliate expressly acknowledges and agrees that the use of
            the Internet is at its own risk and that this affiliate program is
            provided "as is" and "as available" without any warranties or
            conditions whatsoever, even if expressed or implied. No guarantee is
            made that it will make access to its website possible at any
            particular time or any particular location.
          </p>
          <p style={{ marginTop: "15px" }}>
            8.2. The Company shall in no event be liable to the Affiliate or
            anyone else for any inaccuracy, error or omission in, or loss,
            injury or damage caused in whole or in part by failures, delays or
            interruptions of the {process.env.REACT_APP_LINK} website or the affiliate program.
          </p>

          <h5>9. Indemnity</h5>
          <p style={{ marginTop: "15px" }}>
            9.1. The Affiliate agrees to defend, indemnify and hold the Company
            and its affiliates, successors, officers, employees, agents,
            directors, shareholders and attorneys, free and harmless from and
            against any and all claims and liabilities, including reasonable
            attorneys' and experts' fees, related to or arising from:
          </p>
          <p style={{ marginTop: "15px" }}>
            a) Any breach of the Affiliate's representations, warranties or
            covenants under this Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            b) The Affiliate's use (or misuse) of the marketing materials.
          </p>
          <p style={{ marginTop: "15px" }}>
            c) All conduct and activities occurring under the Affiliate's user
            ID and password.
          </p>
          <p style={{ marginTop: "15px" }}>
            d) Any defamatory, libelous or illegal material contained within the
            Affiliate’s website or as part of the Affiliate's information and
            data.
          </p>
          <p style={{ marginTop: "15px" }}>
            e) Any claim or contention that the Affiliate’s website or the
            Affiliate's information and data infringes any third party's patent,
            copyright, trademark, or other intellectual property rights or
            violates any third party's rights of privacy or publicity.
          </p>
          <p style={{ marginTop: "15px" }}>
            f) Third party access or use of the Affiliate’s website or to the
            Affiliate's information and data.
          </p>
          <p style={{ marginTop: "15px" }}>
            g) Any claim related to the Affiliate website.
          </p>
          <p style={{ marginTop: "15px" }}>
            h) Any violation of this Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            9.2. The Company reserves the right to participate, at its own
            expense in the defense of any matter.
          </p>

          <h5>10. Company Rights</h5>
          <p style={{ marginTop: "15px" }}>
            10.1. In order to comply with company or {process.env.REACT_APP_LINK} policies, and to
            protect the company or {process.env.REACT_APP_LINK}'s interests, the company or {process.env.REACT_APP_LINK} can
            reject any player or close the player account.
          </p>
          <p style={{ marginTop: "15px" }}>
            10.2. The Company may refuse any applicant and/or may close any
            Affiliate’s account if it is necessary to comply with the Company's
            policy and/or protect the interest of the Company. If the Affiliate
            is in breach of this Agreement or the Company’s Terms or other
            rules, policies and guidelines of the Company, the Company may
            besides closing the Affiliate’s account take any other steps in law
            to protect its interests.
          </p>

          <h5>11. Commission Structure</h5>
          <p style={{ marginTop: "15px" }}>
            11.1. The commission settled to the agent is a percentage of the
            game betting amount. The exact commission structure is part of this
            agreement. For details, see the "commission rules" clause. In this
            case, the Commission is withdrawn to the player’s platform wallet
            (digital currency), but not directly to other addresses.
          </p>

          <h5>12. Assignment</h5>
          <p style={{ marginTop: "15px" }}>
            12.1. The Affiliate may not assign this Agreement, by operation of
            law or otherwise, without obtaining the prior written consent of the
            Company. In the event that the affiliate acquires or otherwise
            obtains control of another affiliate of {process.env.REACT_APP_LINK}, then accounts will
            coexist on individual terms.
          </p>
          <p style={{ marginTop: "15px" }}>
            12.2. The Company may assign this Agreement, by operation of the law
            or otherwise, at any time without obtaining the prior consent of the
            Affiliate.
          </p>

          <h5>13. Non-Waiver</h5>
          <p style={{ marginTop: "15px" }}>
            13.1. The Company's failure to enforce the Affiliate's adherence to
            the Terms outlined in this Agreement shall not constitute a waiver
            of the right of the Company to enforce said terms at any time.
          </p>

          <h5>14. Force Majeure</h5>
          <p style={{ marginTop: "15px" }}>
            14.1. Neither party shall be liable to the other for any delay or
            failure to perform its obligations under this Agreement if such
            delay or failure arises from a cause beyond the reasonable control
            of and is not the fault of such party, including but not limited to
            labour disputes, strikes, industrial disturbances, acts of God, acts
            of terrorism, floods, lightning, utility or communications failures,
            earthquakes or other casualty. If a force majeure event occurs, the
            non-performing party is excused from whatever performance is
            prevented by the force majeure event to the extent prevented.
            Provided that, if the force majeure event subsists for a period
            exceeding thirty (30) days then either party may terminate the
            Agreement without notice.
          </p>

          <h5>15. Relationship of the Parties</h5>
          <p style={{ marginTop: "15px" }}>
            15.1. Nothing contained in this Agreement, nor any action taken by
            any party to this Agreement, shall be deemed to constitute either
            party (or any of such party's employees, agents, or representatives)
            an employee, or legal representative of the other party, nor to
            create any partnership, joint venture, association, or syndication
            among or between the parties, nor to confer on either party any
            express or implied right, power or authority to enter into any
            Agreement or commitment on behalf of (nor to impose any obligation
            upon) the other party.
          </p>

          <h5>16. Severability/Waiver</h5>
          <p style={{ marginTop: "15px" }}>
            16.1. Whenever possible, each provision of this Agreement shall be
            interpreted in such a manner as to be effective and valid under
            applicable law but, if any provision of this Agreement is held to be
            invalid, illegal or unenforceable in any respect, such provision
            will be ineffective only to the extent of such invalidity, or
            unenforceability, without invalidating the remainder of this
            Agreement. No waiver will be implied from conduct or failure to
            enforce any rights and must be in writing to be effective.
          </p>

          <h5>17. Confidentiality</h5>
          <p style={{ marginTop: "15px" }}>
            17.1. All information, including but not limited to business and
            financial, lists of customers and buyers, as well as price and sales
            information and any information relating to products, records,
            operations, business plans, processes, product information, business
            know-how or logic, trade secrets, market opportunities and personal
            data of the Company shall be treated confidentially. Such
            information must not be used for own commercial or other purposes or
            divulged to any person or third party neither directly nor
            indirectly unless prior explicit and written consent has been
            provided by the Company. This provision shall survive the
            termination of this Agreement.
          </p>
          <p style={{ marginTop: "15px" }}>
            17.2. The Affiliate obliges himself/herself not to use the
            confidential information for any purpose other than the performance
            of its obligations under this Agreement.
          </p>

          <h5>18. Changes to this Agreement</h5>
          <p style={{ marginTop: "15px" }}>
            18.1. The Company reserves the right to amend, alter, delete or add
            to any of the provisions of this Agreement, at any time and at its
            sole discretion, without giving any advance notice to the Affiliate
            subject to the Terms set out in this Agreement. Any such changes
            will be published on {process.env.REACT_APP_LINK}.
          </p>
          <p style={{ marginTop: "15px" }}>
            18.2. In case of any discrepancy between the meanings of any
            translated versions of this Agreement, the English language version
            shall prevail.
          </p>

          <h5>19. Trademarks</h5>
          <p style={{ marginTop: "15px" }}>
            19.1. Nothing contained in this Agreement will grant either party
            any right, title or interest in the trademarks, trade names, service
            marks or other intellectual property rights [hereinafter referred to
            simply as ‘Marks’] of the other party. At no time during or after
            the term will either party attempt or challenge or assist or allow
            others to challenge or to register or to attempt to register the
            Marks of the other party or of any company within the group of
            companies of the other party. Provided also that neither of the
            parties will register nor attempt to register any Mark which is
            basically similar to and/or confusingly similar to any Mark which
            belongs to the other party or to any company contained within the
            other party’s group of companies.
          </p>
        </div>
      </Modal>
      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default Dashboard;
